<template>
  <HeaderViewDesktop v-if="isDesktop">
    <slot />
  </HeaderViewDesktop>
  <HeaderViewMobile v-else>
    <slot />
  </HeaderViewMobile>
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderViewDesktop from './header-view-desktop';
import HeaderViewMobile from './header-view-mobile';

export default {
  components: { HeaderViewDesktop, HeaderViewMobile },
  computed: {
    ...mapGetters('layoutModule', ['isDesktop']),
  }
};
</script>
